export const VAT_RATE_DECIMAL_SEPARATOR = ',';

export function formatVatRate(value: number | string): string {
  if (value === null || value === undefined || value === '') { return ''; }

  return String(value).replace('.', VAT_RATE_DECIMAL_SEPARATOR);
}

export function formatVatRateLabel(value: number | string): string {
  const formattedValue = formatVatRate(value);

  return formattedValue === '' ? '' : `${formattedValue}%`;
}
